import React from 'react';
import { useAuth } from '../../auth/AuthContext';

function Guard({ permission, anyOf, fallback = null, children }) {
  const { hasPermission, hasAnyPermission } = useAuth();

  if (permission && !hasPermission(permission)) {
    return fallback;
  }

  if (Array.isArray(anyOf) && anyOf.length && !hasAnyPermission(anyOf)) {
    return fallback;
  }

  return children;
}

export default Guard;
